<template>
  <div class="section animation-swiper">
    <div class="row swiper">
      <div class="row text-center" v-if="title">
        <h4>{{ title }}</h4>
      </div>

      <mq-tabs class="tabs" :selectedIndex="selectedIndex" :items="slides" @select="newTabSelectedWithClick">
        <mq-tab slot="tab" slot-scope="props"
          :color="teamsiteConfig.color"
          :icon="props.item.icon"
          :title="props.item.title"
        ></mq-tab>
      </mq-tabs>

      <div class="row">
        <div class="column small-22 small-centered">
          <div class="row collapse">
            <div class="column small-24 mediumlarge-12 mediumlarge-push-12">
              <mq-animation ref="animation" :animationData="animationData" :segments="animationSegments" />
            </div>

            <div class="column small-24 mediumlarge-12 mediumlarge-pull-12" v-for="(slide, index) in slides" :key="index" :class="['panel', `panel-${index}`]">
              <div class="text-anim-container">
                <div class="text">
                  <h2>{{ slide.title }}</h2>
                  <p v-html="interpolate(slide.text)"></p>
                  <mobile-app class="app_buttons" v-if="teamsiteConfig.app && slide.name === 'slide_app'" :app="teamsiteConfig.app"></mobile-app>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('waypoints/lib/noframework.waypoints.js')

export default {
  name: 'animation-content-swiper',

  props: {
    title: {
      type: String,
      required: true
    },
    animationData: {
      type: Object,
      required: false
    },
    animationSegments: {
      type: Array,
      required: true
    },
    slides: {
      type: Array,
      required: true
    }
  },

  methods: {
    newTabSelectedWithClick (tabIndex) {
      this.newTabSelected(tabIndex)
      this.$el.querySelector('.animation').classList.add('clicked')
    },
    newTabSelected (tabIndex) {
      if (this.slideShowInterval) clearInterval(this.slideShowInterval)

      this.selectedIndex = tabIndex
      let panels = Array.from(this.$el.querySelectorAll('.panel'))
      panels.forEach(el => el.classList.remove('panel-active'))
      this.$el.querySelector(`.panel-${this.selectedIndex}`).classList.add('panel-active')

      if (this.$refs.animation) {
        this.$refs.animation.playSegment(tabIndex)
      }
    },

    startSlideShow() {
      this.slideShowInterval = setInterval(this._nextSlide, 7500)
    },

    _nextSlide() {
      if (this.selectedIndex === this.slides.length - 1) {
        clearInterval(this.slideShowInterval)
        return
      }

      this.newTabSelected (this.selectedIndex + 1)
      this.startSlideShow()
    }
  },

  mounted () {
    const element = this.$el
    element.querySelector('.panel-0').classList.add('panel-active')

    const wp = new Waypoint({
      element: element,
      offset: '75%',
      continuous: false,
      handler: () => {
        const animationStart = setInterval(() => {
          if (!this.$refs.animation || !this.$refs.animation.animation.isLoaded) {
            return
          }

          this.$refs.animation.playNextSegment()
          this.startSlideShow()
          clearInterval(animationStart)
        }, 100)

        wp.destroy()
      }
    })
  },

  data () {
    return {
      selectedIndex: 0
    }
  }
}
</script>

<style lang="scss">


.animation-swiper {
  background-size: cover;
  background-position: bottom right;
  background-image: url('../assets/stripes.svg');
  position: relative;
  height: calc(100vh - 85px);
  min-height: rem-calc(700);
  overflow: hidden;

  @include breakpoint(medium down) {
    height: auto;
  }

  h4 {
    color: $black;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .tabs {
    margin-bottom: 20px;
    position: relative;
    z-index: 1;

    @include breakpoint(medium up) {
      margin-bottom: 40px;
    }
  }

  .animation-container.clicked {
    .text {
      animation: text-clicked 7.5s ease-in-out;
    }
  }

  .panel {
    .text {
      display: none;
      opacity: 0;
      animation: text 7.5s ease-in-out;
      animation-fill-mode: forwards;

      &:last-child {
        animation: text-clicked 7.5s ease-in-out;
      }

      h2 {
        color: $black;
        @include breakpoint(medium down) {
          margin-top: 0;
        }
      }

      .app_buttons{
        margin-bottom: 1rem;
      }
    }
  }

  .animation svg {
    width: 100% !important;
    height: auto !important;
    max-height: 550px;

    @include breakpoint(medium down) {
      transform: translateX(4rem) scale(1.5) !important;
      display: block;
      width: 70% !important;
      margin-top: 0;
      margin-bottom: 0;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    @include breakpoint(small only) {
      float: left;
      width: 90% !important;
      max-height: 450px;
    }
  }

  .panel-active {
    .text {
      display: block;
      opacity: 1;
    }
  }
}

@keyframes text {
  0%, 100% {
    opacity: 0;
    transform: translateX(-100px);
  }
  3%, 97% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes text-clicked {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  3% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnimationContentSwiper.vue